import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function Popup({
  isOpen,
  setIsOpen,
  headerText,
  bodyText,
  cancelBtnText,
  confirmBtnText,
  onConfirm = () => {},
}) {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={isOpen} sx={{ p: 0 }}>
      <Box sx={{ width: "320px" }}>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "3px",
            textAlign: "center",
          }}
          id="customized-dialog-title"
        >
          <img src={CloseIcon} alt="close" onClick={handleClose} />
          <Typography
            className="open-sans-hebrew"
            gutterBottom
            sx={{
              fontSize: "24px",
              m: 0,
              color: "var(--darkblue)",
              textAlign: "center",
              fontWeight: 700,
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {headerText}
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent>
        <Typography
          className="test"
          sx={{
            fontFamily: `var(--font-family) !important`,
            fontSize: "16px",
            m: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            alignItems: "flex-end",
            mb: "46px",
          }}
        >
          {bodyText && Array.isArray(bodyText)
            ? bodyText.map((el) => (
                <Typography
                  sx={{
                    fontFamily: `var(--font-family) !important`,
                    fontSize: "16px",
                    m: 0,
                    textAlign: "center",
                    color: "#565656",
                  }}
                >
                  {el}
                </Typography>
              ))
            : bodyText}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: "0px" }}>
        <Button
          onClick={() => {
            handleClose();
            onConfirm();
          }}
          sx={{ py: "16px" }}
          variant="contained"
          className="phone-dialog-btn phone-dialog-darkblue-btn"
        >
          {confirmBtnText}
        </Button>
        <Button
          sx={{ py: "16px" }}
          variant="contained"
          className="phone-dialog-btn phone-dialog-red-btn"
          onClick={handleClose}
        >
          {cancelBtnText}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
